import Slider from 'react-slick';
import styles from './PhotoCarousel.module.scss';
import img1 from '../../images/carousel1/IMG_0421.webp';
import img2 from '../../images/carousel1/IMG_0453.webp';
import img3 from '../../images/carousel1/IMG_0561.webp';
import img4 from '../../images/carousel1/IMG_0618.webp';
import img5 from '../../images/carousel1/IMG_1443.webp';
import img6 from '../../images/carousel1/IMG_1929.webp';
import img7 from '../../images/carousel1/IMG_2088.webp';
import img8 from '../../images/carousel1/IMG_2371.webp';
import img9 from '../../images/carousel1/IMG_4364.webp';
import img10 from '../../images/carousel1/IMG_5014.webp';

const settings = {
  className: 'slider variable-width',
  arrows: false,
  focusOnSelect: true,
  infinite: true,
  centerMode: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const images: string[] = [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10];

type PhotoCarouselProps = {
  background?: string;
};

function PhotoCarousel({ background = 'var(--color-dark-yellow)' }: PhotoCarouselProps) {
  return (
    <div className={styles.container} style={{ backgroundColor: background }}>
      <div className={styles.carousel}>
        <Slider {...settings}>
          {images.map((src, index) => (
            <div key={src} className={styles.item}>
              <img draggable={false} src={src} alt={`img-${index}`} />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}

export default PhotoCarousel;
